import type { SelectableApplicationRow } from '../../types/physicalCargoSource';

export function buildSelectableApplicationSelectOptions(rows: SelectableApplicationRow[]) {
  return rows.map((row) => ({
    value: row.id,
    label: row.clientName?.trim()
      ? `Заявка ${row.internalNumber} — ${row.clientName}`
      : `Заявка ${row.internalNumber}`,
    searchText: `${row.internalNumber} ${row.clientName ?? ''}`.toLowerCase()
  }));
}
